import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import {
    FaMinusSquare,
    FaPlusSquare,
    FaChevronRight,
    FaChevronDown,
} from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";

function RelatedCorporatestable({ data = [], isSubScribe, companyInfo }) {
    const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
    const [openSections, setOpenSections] = useState({
        foreginCorporates: true,
        relatedCorporates: true,
        holdingCorporates: true,
        subsidiaryCorporates: true,
        associateCorporates: true,
        jointVentures: true,
    });

    // dynamic category open state (initialized from groupedData)
    const [categoryOpen, setCategoryOpen] = useState({});
    // per-row expanded state to show ref docs
    const [expandedRows, setExpandedRows] = useState({});

    const toggleSection = (section) => {
        if (!isSubScribe) {
            alert("Please unlock to see the data.");
            return;
        }
        setOpenSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    // filtered by financial year when selected
    const filteredData = selectedFinancialYear
        ? data.filter((corp) => corp.financialYear === selectedFinancialYear)
        : data;

    // Grouping data by category (normalized key)
    const groupedData = filteredData.reduce((acc, corp) => {
        const category = (corp.category || "").toLowerCase().replace(/ /g, "");
        if (!acc[category]) acc[category] = [];
        acc[category].push(corp);
        return acc;
    }, {});

    useEffect(() => {
        if (data && data.length > 0 && !selectedFinancialYear) {
            const availableYears = data
                .map((item) => item.financialYear)
                .filter((value, index, self) => self.indexOf(value) === index);
            setSelectedFinancialYear(availableYears[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // initialize category open state when groupedData changes
    useEffect(() => {
        const keys = Object.keys(groupedData || {});
        const init = {};
        keys.forEach((k) => (init[k] = true));
        setCategoryOpen((prev) => ({ ...init, ...prev }));
    }, [selectedFinancialYear, data]);

    // toggle a dynamic category header
    const toggleCategory = (category) => {
        if (!isSubScribe) {
            alert("Please unlock to see the data.");
            return;
        }
        setCategoryOpen((prev) => ({ ...prev, [category]: !prev[category] }));
    };

    // toggle a row to show/hide reference documents
    const toggleRow = (id) => {
        if (!isSubScribe) {
            alert("Please unlock to see the data.");
            return;
        }
        setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    // render reference documents for a single item
    const renderRefDocs = (item) => {
        if (!item?.refDoc)
            return <span>No documents available for selected year</span>;

        return (
            <div className={styles.referencedoc_main}>
                <div>
                    <b>Reference Documents</b>
                </div>

                <div className={styles.referencedoc_container}>
                    {item.refDoc?.MaiinFileName && (
                        <a
                            href={item.refDoc?.fileurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.referencedoc_mainfilename}>
                            {item.refDoc?.MaiinFileName}
                        </a>
                    )}

                    <ul style={{ padding: 0 }}>
                        {item.refDoc?.Attachments &&
                        item.refDoc?.Attachments.length > 0 ? (
                            item.refDoc.Attachments.map((attachment, index) => (
                                <li
                                    key={index}
                                    className={styles.referencedoc_Attachments}>
                                    <IoDocumentTextOutline
                                        size={16}
                                        style={{
                                            marginRight: "8px",
                                            color: "#2961EF",
                                        }}
                                    />
                                    <a
                                        href={attachment.fileurl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: "none",
                                            color: "#2961EF",
                                        }}>
                                        {attachment.Name}
                                    </a>
                                    <button
                                        onClick={() => {
                                            const link =
                                                document.createElement("a");
                                            link.href = attachment.fileurl;
                                            link.download = attachment.Name;
                                            link.click();
                                        }}
                                        title="Download"
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#2961EF",
                                            marginLeft: "5px",
                                            textDecoration: "underline",
                                        }}>
                                        <FiDownload />
                                    </button>
                                </li>
                            ))
                        ) : (
                            <span>No attachments available.</span>
                        )}
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <div className={styles.table_subcontainer}>
            {isSubScribe && (
                <div className={styles.highlet_header_content1}>
                    <h3 className={styles.highlet_text}>
                        <div onClick={() => toggleSection("relatedCorporates")}>
                            {openSections.relatedCorporates ? (
                                <FaMinusSquare size={22} />
                            ) : (
                                <FaPlusSquare size={22} />
                            )}
                        </div>
                        RELATED CORPORATES FOR
                        {filteredData.length > 0 &&
                            selectedFinancialYear &&
                            ` FOR FY ENDING ON - 31 Mar, ${
                                selectedFinancialYear || "All Years"
                            }`}
                    </h3>

                    <div className={styles.yearSelectContainer}>
                        {data && data.length > 0 && (
                            <select
                                value={selectedFinancialYear}
                                onChange={(e) =>
                                    setSelectedFinancialYear(e.target.value)
                                }>
                                {data
                                    .map((item) => item.financialYear)
                                    .filter(
                                        (value, index, self) =>
                                            self.indexOf(value) === index
                                    )
                                    .sort((a, b) => b - a)
                                    .map((year) => (
                                        <option key={year} value={year}>
                                            {parseInt(year) - 1} - {year}
                                        </option>
                                    ))}
                            </select>
                        )}
                    </div>
                </div>
            )}

            {!isSubScribe && (
                <button className={styles.Subscription_msg}>
                    <IoMdLock /> Subscription required to view data
                </button>
            )}

            {openSections.relatedCorporates && (
                <div>
                    <ol>
                        {/* Dynamically render categories from groupedData */}
                        {Object.keys(groupedData).length === 0 && (
                            <p>No records found for selected year.</p>
                        )}

                        {Object.entries(groupedData).map(
                            ([categoryKey, items]) => {
                                // display-friendly category title
                                const title = categoryKey
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/corporates/i, " Companies")
                                    .replace(/company/i, "Company")
                                    .replace(/_/g, " ")
                                    .toUpperCase();

                                return (
                                    <li key={categoryKey}>
                                        <h3 className={styles.highlet_text}>
                                            <div
                                                onClick={() =>
                                                    toggleCategory(categoryKey)
                                                }>
                                                {categoryOpen[categoryKey] ? (
                                                    <FaChevronDown size={16} />
                                                ) : (
                                                    <FaChevronRight size={16} />
                                                )}
                                            </div>
                                            {title}
                                        </h3>

                                        {categoryOpen[categoryKey] &&
                                            isSubScribe && (
                                                <div>
                                                    {/* Table for this category */}
                                                    {items &&
                                                    items.length > 0 ? (
                                                        <table
                                                            className={
                                                                styles.commantable
                                                            }>
                                                            <thead>
                                                                <tr
                                                                    className={
                                                                        styles.tableHeaderRow
                                                                    }>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }></th>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        Corporate
                                                                        Name
                                                                    </th>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        CIN
                                                                    </th>

                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        Preference
                                                                        Shareholding
                                                                    </th>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        Equity
                                                                        Shareholding
                                                                    </th>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        Total
                                                                        Equity
                                                                        Shares
                                                                    </th>
                                                                    <th
                                                                        className={
                                                                            styles.tableHeader
                                                                        }>
                                                                        Total
                                                                        Preference
                                                                        Shares
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {items.map(
                                                                    (corp) => (
                                                                        <React.Fragment
                                                                            key={
                                                                                corp.Id
                                                                            }>
                                                                            <tr
                                                                                className={
                                                                                    styles.tableRow
                                                                                }>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }
                                                                                    style={{
                                                                                        width: 32,
                                                                                    }}>
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            toggleRow(
                                                                                                corp.Id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            background:
                                                                                                "none",
                                                                                            border: "none",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        aria-label="toggle-row">
                                                                                        {expandedRows[
                                                                                            corp
                                                                                                .Id
                                                                                        ] ? (
                                                                                            <FaMinusSquare />
                                                                                        ) : (
                                                                                            <FaPlusSquare />
                                                                                        )}
                                                                                    </button>
                                                                                </td>

                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.corporate_name ||
                                                                                        "-"}
                                                                                </td>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.CIN ||
                                                                                        "-"}
                                                                                </td>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.Preference_Shareholding ??
                                                                                    corp.Preference_Shareholding ===
                                                                                        0
                                                                                        ? corp.Preference_Shareholding
                                                                                        : corp.Preference_Shareholding ||
                                                                                          "-"}
                                                                                </td>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.Equity_Shareholding ??
                                                                                    corp.Equity_Shareholding ===
                                                                                        0
                                                                                        ? corp.Equity_Shareholding
                                                                                        : corp.Equity_Shareholding ||
                                                                                          "-"}
                                                                                </td>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.Total_No_of_Equity_Shares ??
                                                                                        "-"}
                                                                                </td>
                                                                                <td
                                                                                    className={
                                                                                        styles.tableCell
                                                                                    }>
                                                                                    {corp.Total_No_of_Preference_Shares ??
                                                                                        "-"}
                                                                                </td>
                                                                            </tr>

                                                                            {expandedRows[
                                                                                corp
                                                                                    .Id
                                                                            ] && (
                                                                                <tr
                                                                                    className={
                                                                                        styles.tableRow
                                                                                    }>
                                                                                    <td
                                                                                        colSpan={
                                                                                            7
                                                                                        }
                                                                                        className={
                                                                                            styles.tableCell
                                                                                        }>
                                                                                        {renderRefDocs(
                                                                                            corp
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </React.Fragment>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <p>
                                                            This corporate does
                                                            not have any {title}{" "}
                                                            for FY ending on{" "}
                                                            {selectedFinancialYear
                                                                ? selectedFinancialYear
                                                                : "-"}{" "}
                                                            as per our records.
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                    </li>
                                );
                            }
                        )}
                    </ol>
                </div>
            )}
        </div>
    );
}

export default RelatedCorporatestable;
